/**
 * O módulo financeiro registra só a ROTA.
 *
 * O store vuex (`./store`, 921 linhas) saiu no MU-6E etapa 7c: era 100% da
 * conciliação bancária, e ela agora usa
 * `react-apps/financeiro/conciliacao/store` — um singleton de módulo, que
 * atravessa a fronteira entre a casca `.vue` e as raízes React das rotas
 * filhas (um contexto React não atravessaria).
 */
import router from './router'

export default {
  router
}
